import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TvOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tv_off"}/>
}
